export const deliveryFormName = 'addDelivery';

export const DELIVERY_STATUS_TYPES = [
  {
    label: 'Open deliveries',
    value: 'pending',
  },
  {
    label: 'Closed deliveries',
    value: 'past',
  },
];

export const DELIVERY_LIST_KEY = 'deliveries';

export const DELIVERY_SIGN_OUT = 'delivery_sign_out';
export const ADD_DELIVERY = 'add_delivery';
